import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Extraer los estilos de SoftTypography que deseas aplicar
const typographyStyles = {
    fontSize: '1rem', // Ajusta según lo necesario
    fontWeight: 400, // Ajusta según lo necesario
    color: '#344767', // Ajusta según lo necesario
    lineHeight: 1.5,
    textTransform: 'none',
};

function CustomInputText({ initialValue, textAlign }) {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(initialValue);

    const handleBlur = () => {
        setIsEditing(false);
    };

    const handleClick = () => {
        setIsEditing(true);
    };

    const handleChange = e => {
        setValue(e.target.value);
    };

    return (
        <input
            type="text"
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            style={{
                ...typographyStyles,
                border: 'none',
                background: 'none',
                outline: 'none',
                width: '100%',
                textAlign, // Aplica la alineación definida por la prop
            }}
        />
    );
}

CustomInputText.propTypes = {
    initialValue: PropTypes.string.isRequired,
    textAlign: PropTypes.oneOf(['left', 'right']), // Define la prop textAlign como "left" o "right"
};

CustomInputText.defaultProps = {
    textAlign: 'left', // Alineación predeterminada a la izquierda
};

export default CustomInputText;
